import React from 'react';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { HeaderNavItem, StyledNavLink } from '../header-nav-link.component';
import { UserDropdown } from './user-dropdown.component';
import { NavItem, UserSettingsLinksConfig } from '../nav-types.types';
import { useNavRef } from '../../../hooks/use-nav-ref.hook';

const sendNavBarAnalyticsEvent = (action: string) => () =>
  trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
    screen_name: 'Navigation Bar',
    detail: action,
  });

// Get pathname to be passed to useNavRef hook.
const getPathname = (navLink: NavItem) => {
  if (typeof navLink.to === 'string') {
    return navLink.to;
  }
  return navLink.to.pathname;
};

export const NavLinkWithActivePageOverride = ({
  navLink,
}: {
  navLink: NavItem;
}) => {
  const navRef = useNavRef(getPathname(navLink));

  return (
    <StyledNavLink
      ref={navRef}
      to={navLink.to}
      key={navLink.label}
      onClick={sendNavBarAnalyticsEvent(navLink.label)}
    >
      {navLink.label}
    </StyledNavLink>
  );
};

export const DesktopNav = ({
  navLinks,
  userSettingsLinks,
  logo,
}: {
  navLinks: NavItem[];
  userSettingsLinks: UserSettingsLinksConfig[];
  logo?: React.ReactElement;
}) => (
  <>
    {/* Header Nav Logo */}
    <HeaderNavItem css={{ margin: '$half', marginRight: '$one' }}>
      {logo}
    </HeaderNavItem>

    {/* Header Nav Home & Capability Areas */}
    {navLinks.map((navLink) => (
      <HeaderNavItem
        css={{
          margin: '$none $one',
          '@tablet': {
            margin: '$none $half',
          },
        }}
      >
        <NavLinkWithActivePageOverride navLink={navLink} />
      </HeaderNavItem>
    ))}

    {/* Header Nav User Dropdown */}
    <HeaderNavItem
      css={{
        marginLeft: 'auto',
        '.user-dropdown-item_link > div': {
          justifyContent: 'space-between',
        },
      }}
    >
      <UserDropdown userSettingsLinks={userSettingsLinks} />
    </HeaderNavItem>
  </>
);
